<template>
	<li class="tap-tips">
		<div class="tip-container">
			<span>{{ text }}</span>
			<tool-tip :visiable="visiable" :content="content" class="tip-message">
				<svg
					xmlns="http://www.w3.org/2000/svg"
					ref="tipIcon"
					class="tip-icon"
					@mousemove="visiable = true"
					@mouseout="visiable = false"
					@click="visiable = true"
					width="12"
					height="12"
					viewBox="0 0 12 12"
				>
					<path
						:fill="color"
						fill-rule="nonzero"
						d="M5.943 10.971C3.2 10.971.914 8.686.914 5.943.914 3.2 3.2.914 5.943.914S10.97 3.2 10.97 5.943 8.686 10.97 5.943 10.97M5.943 0A5.931 5.931 0 0 0 0 5.943a5.931 5.931 0 0 0 5.943 5.943 5.931 5.931 0 0 0 5.943-5.943A5.931 5.931 0 0 0 5.943 0m0 2.743c-.274 0-.457.183-.457.457v3.657c0 .274.183.457.457.457s.457-.183.457-.457V3.2c0-.274-.183-.457-.457-.457m0 5.486c-.274 0-.457.182-.457.457 0 .274.183.457.457.457s.457-.183.457-.457c0-.275-.183-.457-.457-.457"
						opacity=".8"
					/>
				</svg>
			</tool-tip>
		</div>
	</li>
</template>
<script>
import buyStore from '../../../../utils/buyStore'

export default {
	data() {
		return {
			visiable: false,
		}
	},
	mounted() {
		buyStore.$on('bodyClicked', e => {
			this.closeTip(e)
		})
	},
	methods: {
		closeTip(e) {
			if (e.target !== this.$refs.tipIcon) {
				this.visiable = false
			}
		},
	},
	props: {
		text: String,
		content: String,
		color: {
			type: String,
		},
	},
}
</script>
<style lang="scss" scoped>
.tap-tips {
	position: relative;
}
.tip-container {
	display: flex;
	align-items: center;
}
.tip-message {
	display: inline-block;
	margin-left: 4px;
	line-height: 100%;
	cursor: pointer;
}
.tip-icon {
	display: block;
	text-align: center;
	height: 12px;
	width: 12px;
	cursor: pointer;
}
</style>
